import React, { useState } from 'react';
import { submitRequest } from '../../services/api';
import PrivacyNoticeLink from '../../components/PrivacyNoticeLink';

const REQUEST_TYPES = [
  'Class Change',
  'Schedule Change',
  'Grade Question',
  'Other',
];

export default function StudentRequests() {
  const [type, setType] = useState(REQUEST_TYPES[0]);
  const [details, setDetails] = useState<any>('');
  const [submitting, setSubmitting] = useState<any>(false);
  const [error, setError] = useState<any>('');
  const [submitted, setSubmitted] = useState<any>(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!details.trim()) { setError('Please describe your request.'); return; }
    setSubmitting(true);
    setError('');
    try {
      await submitRequest(type, details);
      setSubmitted(true);
      setDetails('');
    } catch (err: any) {
      setError(err.message || 'Failed to submit request.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div style={{ fontSize: 28, fontWeight: 800, color: 'var(--ae-primary-strong)', marginBottom: 6 }}>
        Submit a Request
      </div>
      <div style={{ color: 'var(--ae-text-muted)', fontSize: 14, marginBottom: 24 }}>
        Send a request to your school admin — class changes, schedule questions, or anything else.
      </div>

      <div style={{ background: 'var(--ae-surface)', border: '1px solid var(--ae-border)', borderRadius: 14, padding: 28, maxWidth: 560, boxShadow: 'var(--ae-shadow-card)' }}>
        {submitted ? (
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#166534', marginBottom: 8 }}>Request submitted!</div>
            <div style={{ color: '#4b7c5a', fontSize: 14, marginBottom: 20 }}>
              Your request has been sent to the school admin for review.
            </div>
            <button
              type="button"
              onClick={() => setSubmitted(false)}
              style={{ background: 'var(--ae-primary)', color: 'white', border: 'none', borderRadius: 8, padding: '9px 20px', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}
            >
              Submit Another
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 6 }}>
                Request Type
              </label>
              <select
                value={type}
                onChange={e => setType(e.target.value)}
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--ae-border)', fontSize: 14, background: 'white', color: 'var(--ae-primary-strong)' }}
              >
                {REQUEST_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 6 }}>
                Details
              </label>
              <textarea
                value={details}
                onChange={e => setDetails(e.target.value)}
                rows={4}
                placeholder="Describe what you need..."
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--ae-border)', fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }}
              />
            </div>
            {error && <div style={{ color: '#b91c1c', fontSize: 13 }}>{error}</div>}
            <button
              type="submit"
              disabled={submitting}
              style={{ background: 'linear-gradient(135deg, var(--ae-primary) 0%, #2f66c9 100%)', color: 'white', border: 'none', borderRadius: 8, padding: '10px 22px', fontWeight: 700, fontSize: 14, cursor: submitting ? 'default' : 'pointer', opacity: submitting ? 0.7 : 1, alignSelf: 'flex-start' }}
            >
              {submitting ? 'Submitting…' : 'Submit Request'}
            </button>
            <PrivacyNoticeLink />
          </form>
        )}
      </div>
    </div>
  );
}
